<template>
  <div class="cover flex-col">
    <el-row class="title" style="margin-left: 5px">
      {{bookName}}
      <el-button style="padding: 6px 9px;" @click="handleHorizontal">{{isHorizontal ? '竖排文字' : '横排文字'}}</el-button>
    </el-row>

    <div
      class="flex flex-grow relative"
      id="contentBox"
      :style="{ cursor: rightOpera.isMouseDown ? 'ew-resize' : '',
                 paddingTop: '5px'}"
      @mousemove="moveClient"
      @mouseup="mouseUp"
    >
      <div
        class="tree-list"
        :style="!isLeftTree ? {width: '30px', overflow: 'hidden', backgroundColor: 'white', padding: '5px 5px'} : {}"
        style="height: calc(100vh - 11rem);"
        ref="leftDragCate"
      >
        <div
          v-show="isLeftTree"
          class="drag-box"
          @mousedown="getClientInfo($event, 'leftDragCate')"
        ></div>

        <div class="justify-between align-center" style="margin-bottom: 10px">
          <img
            v-if="isLeftTree"
            src="/static/icon/left.png"
            class=""
            @click="isLeftTree = !isLeftTree"
          />
          <img
            v-if="!isLeftTree"
            src="/static/icon/right.png"
            @click="isLeftTree = !isLeftTree"
          />
        </div>
        <el-table ref="myTable" v-show="isLeftTree" v-loading="loading" :data="pageList" :show-header="false"
                  highlight-current-row
                  @row-click="onPicSel">
          <el-table-column label="pagePic" align="center" prop="pagePic">
            <template slot-scope="scope">
              <el-image
                :src="baseUrl + scope.row.pagePicThumb"
              ></el-image>
              <div>{{scope.row.fileName}}</div>
            </template>
          </el-table-column>
        </el-table>
<!--        <pagination-->
<!--          v-show="isLeftTree && total>0"-->
<!--          :total="total"-->
<!--          :background="false"-->
<!--          layout="prev, pager, next"-->
<!--          :pager-count="5"-->
<!--          :small="true"-->
<!--          :page.sync="queryParams.pageNum"-->
<!--          :limit.sync="queryParams.pageSize"-->
<!--          @pagination="getPageList"-->
<!--        />-->
        <el-pagination
          v-show="isLeftTree && total>0"
          :small="true"
          :background="false"
          :current-page.sync="queryParams.pageNum"
          :page-size.sync="queryParams.pageSize"
          layout="prev, pager, next"
          :pager-count="5"
          :total="total"
          @current-change="getPageList"
        />
      </div>

<!--      <div style="position: absolute; top: 20px;z-index: 10000" :style="{right: zoomBtnRight + 'px'}">-->
<!--        <el-button size="mini" circle icon="el-icon-zoom-in" @click="handleZoom('in')" />-->
<!--        <el-button size="mini" circle icon="el-icon-zoom-out" @click="handleZoom('out')" />-->
<!--      </div>-->

      <div
        id="picBox" ref="picBox"
        class="flex-grow"
        v-show="isOperaText"
        style="height: calc(100vh - 11rem); overflow: auto; margin-left: 10px; margin-right: 10px; position: relative"
      >
        <div :style="{width: currentRow.picWidth * ratio + 'px', height: currentRow.picHeight * ratio + 'px'}">
            <img
              id="srcImg"
              style="width:100%; height: 100%; object-fit: contain;"
                 :src="baseUrl + currentPagePic"
                 @click="cancelSel"
            >
          <div v-for="(item, index) in currentBox">
            <div :id="'pic' + index" v-if="selMap[index]" class="sel-border"
                 :style="{top: parseInt(item.box[1]) + 'px', left: parseInt(item.box[0]) + 'px',
                        height:parseInt(item.box[5]) - parseInt(item.box[3]) + 'px',
                        width:parseInt(item.box[2]) - parseInt(item.box[0]) + 'px',
                        position: 'absolute', borderColor: picBorderStyle(index)}"
            ></div>
            <div :id="'pic' + index" v-else :class="rectType != 'hidden' ? 'default-border' : ''"
                 :style="{top: parseInt(item.box[1]) + 'px', left: parseInt(item.box[0]) + 'px',
                        height:parseInt(item.box[5]) - parseInt(item.box[3]) + 'px',
                        width:parseInt(item.box[2]) - parseInt(item.box[0]) + 'px',
                        position: 'absolute', borderColor: picBorderStyle(index)}" @click="clickSplitPic(index)"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="text-opera"
        ref="opearBox"
        id="opearBox"
        style="height: calc(100vh - 11rem);"
      >

        <div style="position: absolute; top: 0; left: -90px; z-index: 1999">
          <el-button id="zoomInButton" size="mini" circle icon="el-icon-zoom-in" />
          <el-button id="zoomOutButton" size="mini" circle icon="el-icon-zoom-out" />
        </div>

        <div
          class="drag-box"
          @mousedown="getClientInfo($event, 'opearBox')"
        ></div>
        <div
          class="auto-scroll"
          style="height: 100%; padding-left:10px;  background-color: #F8F7F3"
          :style="isHorizontal ? '' : {display: 'flex', flexDirection: 'row-reverse'}">
          <div v-for="(item, index) in currentBox" :key="index" @click="clickSplitPic(index)">
            <div v-if="isHorizontal" :style="{ width: inputWidth(item.text, item.type), marginBottom: '10px'}"
                 style="display: flex; align-items:center; text-align: center">
              <span v-if="isSort" style="font-size: 12px; width: 30px; margin-left: -10px" :style="{color: selMap[index] ? '#EB7652' : '#C3BDA7'}">{{index + 1}}</span>
              <el-input :ref="'text' + index" :id="'text' + index"  class="inputDeepBorder"
                        :class="inputClass(index)"
                        v-model="item.text">
                <template slot="prepend"><div style="width: 2px;"></div></template>
              </el-input>
            </div>
            <div v-if="!isHorizontal" :style="{ paddingLeft: '10px', height: inputHeight(item.text, item.type)}">
              <div style="width: 100%; height: 2px;" :style="{backgroundColor: textAreaPrepend(item.text, item.type)}"></div>
            <el-input :ref="'text' + index" :id="'text' + index" v-if="!isHorizontal" class="inputDeepBorder"
                      type = "textarea"
                      resize = "none"
                      :class="inputClass(index)"
                      style="height: calc(100% - 5px)"
                      :style="{top: parseInt(item.box[1]) - 3 + 'px'}"
                      v-model="item.text">
             </el-input>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  bookPageList,
  pageBoxInfo
} from "@/api/api";
import variables from "../assets/variables.less";
import Big from 'big.js'

export default {
  name: "PageViewer",
  data() {
    return {
      bookId: null,
      bookName: '',
      pageList: [],
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      // 总条数
      total: 0,
      baseUrl: window.__baseUrl__,
      currentPagePic: "",
      contentDelta: [
      ],
      contentChangeDelta: [],
      isHorizontal: false,
      isOperaText: true,
      rightOpera: {},
      isLeftTree: true,
      isShowEditPic: true,
      currentBox: null,
      splitPicList: [],
      currentPageSplitPath: "",
      currentPageSplitSuffix: "",
      currentSpiltIndex: [],
      currentSpiltIndexStr: '',
      isSort: false,
      currentFont: '',

      selMap: {},
      selNewMap: {},

      isNew: false,
      isSortChange: false,
      pageSortMap: {
        sort: {},
        font: {}
      },
      newMouseDown: false,
      currentRow: {},
      ocrStatusText: {
        0: 'OCR未开始',
        10: 'OCR进行中',
        20: 'OCR完成',
        30: 'OCR发送失败',
        35: 'OCR识别失败',
        40: '文字调整',
        50: '段落调整',
        60: '已完成'
      },
      ocrStatusOptions: [
        {
          value: 0,
          label: '待完成',
        },
        {
          value: 60,
          label: '已完成',
        }
      ],
      lightChange: '',
      isMerge: false,
      newAreaStartPos: {},
      isDrag: false,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      top: 0,
      left: 0,
      loadingOcr: false,
      updateDelta: [],
      isEdit: false,
      operaList: [],
      operaStackList: [],
      currentStackIndex: 0,
      stackSize: 30,
      isShowRect: false,
      splitImgList: [],
      canvas: null,
      ctx: null,
      ratio: 1,
      isZoom: false,
      rectTypeOptions: [
        {label: "隐藏框", value: 'hidden'},
        {label: "白色框", value: 'white'},
        {label: "深色框", value: 'brown'},
      ],
      rectType: "hidden",
      currentHighlightColor: '',
      pageId: null,
      currentIndex: 0
    };
  },
  computed: {
    variables() {
      return variables;
    },
  },
  created() {
    if (this.$route.query && this.$route.query.bookId) {
      this.bookId = parseInt(this.$route.query.bookId)
      this.queryParams.bookId = this.bookId
    }
    if (this.$route.query && this.$route.query.bookName) {
      this.bookName = this.$route.query.bookName
    }

    if (this.$route.query && this.$route.query.pageId) {
      this.pageId = parseInt(this.$route.query.pageId)
      this.queryParams.pageId = this.bookId
    }


    if (this.$route.query && this.$route.query.juanNum) {
      let juanNum = parseInt(this.$route.query.juanNum)
      this.queryParams.pageNum = Math.ceil(juanNum / this.queryParams.pageSize)
      this.currentIndex = juanNum % this.queryParams.pageSize - 1
    }

    this.getPageList()
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);

// 获取按钮元素
    let inBtn = document.getElementById('zoomInButton');

// 为按钮添加鼠标按下事件监听器
    inBtn.addEventListener('mousedown', this.handleZoomIn);

    let outBtn = document.getElementById('zoomOutButton');
    outBtn.addEventListener('mousedown', this.handleZoomOut);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },

  methods: {
     /** 查询书页列表 */
    getPageList() {
      this.loading = true;
      bookPageList(this.queryParams).then(response => {
        this.resetPic()
        this.pageList = response.rows;
        this.$refs.myTable.setCurrentRow(this.pageList[this.currentIndex]);
        if(this.pageList.length > 0) {
          this.getDetail(this.pageList[this.currentIndex])
        }
        this.total = response.total;
        this.loading = false;
      });
    },

    handleHorizontal() {
      this.isHorizontal = !this.isHorizontal
    },
    onPicSel(row, column, event) {
      this.resetPic()
      this.getDetail(row)
    },
    getDetail(row) {
      this.currentRow = row
      this.currentPagePic = row.pagePic
      // this.pageSortMap = row.picResort ? JSON.parse(row.picResort) : {};
      // pageBoxInfo(row.id).then(response => {
        this.currentBox = row.pageJson ? JSON.parse(row.pageJson) : [];
      for(let i = 0; i < this.currentBox.length; i++) {
        let box = this.currentBox[i].box
        let width = parseInt(box[2]) - parseInt(box[0])
        if(width != 0) {
          if(width >= 45) {
            this.currentBox[i].type = 'header'
          } else if(width >= 35) {
            this.currentBox[i].type = 'big'
          } else if(width >= 20) {
            this.currentBox[i].type = 'normal'
          } else {
            this.currentBox[i].type = 'small'
          }
        }
      }

        const container = document.getElementById('picBox')
        // 计算滚动条所能达到的最大值
        const maxScrollX = container.scrollWidth - container.clientWidth;

        // 将滚动条移动到最右边
        container.scrollTo(maxScrollX, 0);
      // });
      let temp = this.currentPagePic.split('.')
      this.currentPageSplitPath = temp[0] + '/'
      this.currentPageSplitSuffix = temp[1]
    },
    //
    getClientInfo (e, ele) {
      console.log('getClientInfo', e)
      this.dragEle = ele
      this.rightOpera = {
        width: this.$refs[ele].$el
          ? this.$refs[ele].$el.clientWidth
          : this.$refs[ele].clientWidth,
        startX: e.clientX,
        isMouseDown: true,
      }
    },
    moveClient (e, ele) {
      if (this.rightOpera.isMouseDown) {
        e.stopPropagation()
        e.preventDefault()
        const {startX} = this.rightOpera
        let offsetWidth = e.clientX - startX
        if (this.dragEle === "leftDragCate") {
          offsetWidth = startX - e.clientX
        }

        let el = this.$refs[this.dragEle].$el || this.$refs[this.dragEle]
        el.style.width = this.rightOpera.width - offsetWidth + "px"
      }
    },
    mouseUp (e, ele) {
      console.log('mouseUp', e.target.parentNode.id)
      if(e.target.id == 'zoomInButton' || e.target.id == 'zoomOutButton' ||
        e.target.parentNode.id == 'zoomInButton' || e.target.parentNode.id == 'zoomOutButton') {
        this.isZoom = false
        if(this.currentSpiltIndex.length > 0) {
          // this.$nextTick(() => {
            for (let i = 0; i < this.currentSpiltIndex.length; i++) {
              this.clickSplitPic(this.currentSpiltIndex[i])
            }

            // let picDoc = document.getElementById('pic' + this.currentSpiltIndex[0])
            // picDoc.scrollIntoView({behavior: 'smooth'})
          // })
        }
      }
      this.rightOpera = {
        isMouseDown: false
      }
    },


    clickSplitPic(index) {
      this.selMap = {}
      this.$set(this.selMap, index, 1)
      this.currentSpiltIndex.splice(0, 1, index)
      this.currentFont = this.currentBox[index].type

      if (this.currentSpiltIndex.length > 0) {
        if (this.currentRow.ocrStatus < 50 && !this.isSort) {
          let textDoc = document.getElementById('text' + this.currentSpiltIndex[0])
          textDoc.focus()
          textDoc.scrollIntoView({behavior: 'smooth'})
        }
        let picDoc = document.getElementById('pic' + this.currentSpiltIndex[0])
        picDoc.scrollIntoView({behavior: 'smooth'})
      }
    },
    cancelSel() {
      this.currentSpiltIndex = []
      this.selMap = {}
    },

    resetPic() {
      this.currentSpiltIndex = []
      this.selMap = {}
      this.operaStackList = []
      this.currentStackIndex = 0
      this.operaList = []
      this.isSort = false
      this.ratio = 1
      this.currentSpiltIndexStr = ''
      this.currentIndex = 0
      // this.rectType = "hidden";
    },

    inputWidth(text, type) {
      let fontsize = 18
      if(type) {
        let temp = variables['jd' + this.titleCase(type) + 'FontSize'].replace('px', '')
        fontsize = parseInt(temp)
      }

      let realLen = 0
      if(text.length == 0) {
        realLen = 100
      }
      realLen = text.length * fontsize + 40
      const container = document.getElementById('opearBox')
      let clientWidth = container.clientWidth
      if(realLen > clientWidth) {
        return realLen + 'px'
      }
      return '100%'
    },
    inputHeight(text, type) {
      let fontsize = 18
      if(type) {
        let temp = variables['jd' + this.titleCase(type) + 'FontSize'].replace('px', '')
        fontsize = parseInt(temp)
      }

      let realLen = 0
      if(text.length == 0) {
        realLen = 100
      }
      realLen = text.length * fontsize + 40
      const container = document.getElementById('opearBox')
      let clientWidth = container.clientHeight
      if(realLen > clientWidth) {
        return realLen + 'px'
      }
      return '100%'
    },
    inputClass(index) {
      let temp = this.currentBox[index].type
      if(!temp) {
        temp = 'normal'
      }
      let colorClass = 'inputDeep' + this.titleCase(temp)
      if(this.selMap[index] != undefined) {
        colorClass += ' inputDeepSel' + this.titleCase(temp)
      }
      return colorClass
    },
    textAreaPrepend(text, type) {
      if(!type) {
        type = 'normal'
      }
      return variables['jd' + this.titleCase(type) + 'FontColor']
    },
    picBorderStyle(index) {
      if(this.selMap[index] != undefined) {
        let temp = this.currentBox[index].type
        if(!temp) {
          temp = 'normal'
        }
        return variables['jd' + this.titleCase(temp) + 'FontColor']
      } else {
        if(this.rectType == 'hidden') {
          return 'none'
        }else if(this.rectType == 'white') {
          return variables['jdBorderYellowBackColor']
        } else {
          return variables['jdBorderWhiteBackColor']
        }
      }

    },

    handleRatio(oldRatio) {
      for(let i = 0; i < this.currentBox.length; i++) {
        let box = this.currentBox[i].box
        for(let j = 0; j < box.length; j++) {
          box[j] = this.timesFloat(box[j], this.divFloat(this.ratio, oldRatio, 10), 10)
        }
        // this.$set(this.currentBox[i], 'box', box)
      }
    },
    handleZoomIn(event) {
      this.handleZoom('in')
    },
    handleZoomOut(event) {
      this.handleZoom('out')
    },
    handleZoom(val) {
      console.log('handleZoom:' + val)
      this.isZoom = true
      let ratio = this.ratio
      if(val == 'in') {
        if(this.ratio >= 2) {
          return
        }
        this.ratio = this.sumFloat(ratio, 0.1)
      } else {
        if(this.ratio <= 0.1) {
          return;
        }
        this.ratio = this.sumFloat(ratio, -0.1)
      }
      this.selMap = {}
      this.handleRatio(ratio)
    },
  // 将数字转换为整数
    toInteger(num) {
      return num * Math.pow(10, 1); // 假设我们需要两位小数
    },

  // 将计算后的整数转换回原来的小数形式
    fromInteger(num) {
      return num / Math.pow(10, 1);
    },
    titleCase(str) {
      return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
    },
    sumFloat(val1, val2) {
      let x = new Big(val1);
      let y = new Big(val2);
      return x.plus(y)
    },

    minusFloat(val1, val2) {
      let x = new Big(val1);
      let y = new Big(val2);
      return x.minus(y)
    },

    timesFloat(val1, val2, fixed) {
      let x = new Big(val1);
      let y = new Big(val2);
      return (x.times(y)).toFixed(fixed)
    },

    divFloat(val1, val2, fixed) {
      let x = new Big(val1);
      let y = new Big(val2);
      return (x.div(y)).toFixed(fixed)
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/variables";
/deep/ .el-table__body tr.current-row>td {
  border: 2px solid #EB7652;
}
/deep/ .inputDeepBorder {
  .el-input__inner{
    border: 1px solid #EBE9DF;
    border-radius: 0px;
    color: #070707;
    min-width: 100%;
  }
  .el-textarea__inner{
    border: 1px solid #EBE9DF;
    border-radius: 0px;
    text-align: center;
    overflow: hidden;
    color: #070707;
    height: 100%;
    padding: 5px 0 0;
    //height: inherit;
  }
  .el-input-group__append, .el-input-group__prepend {
    padding: 0;
  }
}

//.inputDeepSel /deep/{
//  .el-input__inner{
//    background-color: $jd_sel_background_color;
//  }
//  .el-textarea__inner{
//    background-color: $jd_sel_background_color;
//  }
//}

/deep/ .inputDeepSelHeader {
  .el-input__inner{
    background-color: @jd_header_font_color;
  }
  .el-textarea__inner{
    background-color: @jd_header_font_color;
  }
}

/deep/ .inputDeepSelBig {
  .el-input__inner{
    background-color: @jd_big_font_color;
  }
  .el-textarea__inner{
    background-color: @jd_big_font_color;
  }
}

/deep/ .inputDeepSelNormal {
  .el-input__inner{
    background-color: @jd_normal_font_color;
  }
  .el-textarea__inner{
    background-color: @jd_normal_font_color;
  }
}

/deep/ .inputDeepSelSmall {
  .el-input__inner{
    background-color: @jd_small_font_color;
  }
  .el-textarea__inner{
    background-color: @jd_small_font_color;
  }
}

/deep/ .inputDeepHeader {
  .el-input__inner{
    line-height: @jd_header_font_size * (3/2);
    height: 60px;
    font-size: @jd_header_font_size;
    //color: @jd_header_font_color;
  }
  .el-textarea__inner{
    font-size: @jd_header_font_size;
    width: 52px;
  }
  .el-input-group__append, .el-input-group__prepend {
    padding: 0;
    width: 2px;
    background-color: @jd_header_font_color;
  }
}

/deep/ .inputDeepBig {
  .el-input__inner{
    line-height: @jd_big_font_size * (3/2);
    height: 48px;
    font-size: @jd_big_font_size;
    //color: @jd_big_font_color;
  }
  .el-textarea__inner{
    font-size: @jd_big_font_size;
    width: 42px;
  }
  .el-input-group__append, .el-input-group__prepend {
    padding: 0;
    width: 2px;
    background-color: @jd_big_font_color;
  }
}

/deep/ .inputDeepNormal {
  .el-input__inner{
    line-height: @jd_normal_font_size * (3/2);
    height: 40px;
    font-size: @jd_normal_font_size;
    //color: @jd_normal_font_color;
  }
  .el-textarea__inner{
    font-size: @jd_normal_font_size;
    width: 36px;
  }
  .el-input-group__append, .el-input-group__prepend {
    padding: 0;
    width: 2px;
    background-color: @jd_normal_font_color;
  }
}

/deep/ .inputDeepSmall {
  .el-input__inner{
    line-height: @jd_small_font_size * (3/2);
    height: 36px;
    font-size: @jd_small_font_size;
    //color: @jd_small_font_color;
  }
  .el-textarea__inner{
    font-size: @jd_small_font_size;
    width: 25px;
  }
  .el-input-group__append, .el-input-group__prepend {
    padding: 0;
    width: 2px;
    background-color: @jd_small_font_color;
  }
}


.title {
  font-size: 20px;
  margin-bottom: 10px;
}
.drag-box {
  position: absolute;
  left: 0;
  top: 0;
  cursor: ew-resize;
  width: 8px;
  height: 100%;
  z-index: 999;
}
.cover {
  width: 100%;
  height: 100%;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-row-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.open-icon {
  position: absolute;
  right: 24px;
  top: 14px;
  width: 24px;
  margin-bottom: 10px;
  cursor: pointer;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-grow {
  flex: 1;
  flex-grow: 1;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-right {
  display: flex;
  align-items: flex-end;
}
.auto-scroll {
  overflow: auto;
}

.tree-list {
  padding: 5px 12px;
  width: 250px;
  background: rgba(112, 112, 112, 0.04);
  /*height: 100vh - 6.9rem;*/
  overflow-y: scroll;
  position: relative;
  .drag-box {
    left: initial;
    right: 0;
  }

  img {
    width: 24px;
    //margin-bottom: 10px;
  }
}

.text-opera {
  width: 700px;
  /*height: ~ "calc(100vh - 7rem)";*/
  position: relative;
  border-style: ridge;
  //overflow: auto;
}


.sel-border {
  //border-color: @jd_sel_background_color;
  border-style: solid;
  border-width: 3px;
}

.default-border {
  border-style: solid;
  border-width: 2px;
}

.sort-border {
  border: 1px solid #B49159;
}

.new-border {
  border-color: yellow;
  border-style: ridge;
}
</style>



// WEBPACK FOOTER //
// src/view/pageViewer.vue